// extracted by mini-css-extract-plugin
export default {"Container":"links_Container__yFjPq","Status-active":"links_Status-active__Orl-Z","Status-inactive":"links_Status-inactive__Vi4Qb","balance":"links_balance__1juw7"};